// import './product-catalog-filters'

let $loading = jQuery('.product-catalog-skeleton')
let request;

export function load_products(url, append) {

	show_loading(!append)

	// add wc-ajax to target url
	let target = url + (url.includes('?') ? '&' : '?') + 'gp-ajax=product_archive';

	// Abort previous request if is loading
	if (typeof request !== "undefined") {
		request.abort()
	}

	request = gp_ajax({
		url: target,
		type: "post",
		dataType: 'json',
		data: {append: append},
	})

	// success
	request.done(function (response, textStatus, jqXHR) {
		// Change url
		window.history.replaceState({Url: url}, "", url);
	});

	request.always(function () {
		hide_loading()
	})

	return request
}

export function show_loading(remove_products = false) {

	if (remove_products) {
		jQuery('.product-catalog-products__list').empty()
	}

	if (!remove_products) {
		$loading.addClass('product-catalog-skeleton_spacer')
	}

	jQuery(".product-catalog-count").text('')
	jQuery(".sidebar-product-catalog-filtration__submit-count").text('')
	jQuery('.product-catalog-pagination').hide();
	$loading.show()
}

function hide_loading() {
	$loading.hide()
	$loading.removeClass('product-catalog-skeleton_spacer')
}
